// Main Icons
import SvgAlertOctagon from '@img/icons/alert-octagon.svg?url';
import SvgArrowAltDown from '@img/icons/arrow-alt-down.svg?url';
import SvgArrowAltLeft from '@img/icons/arrow-alt-left.svg?url';
import SvgArrowAltRight from '@img/icons/arrow-alt-right.svg?url';
import SvgArrowAltUp from '@img/icons/arrow-alt-up.svg?url';
import SvgArrowContinuous from '@img/icons/arrow-continuous.svg?url';
import SvgArrowDots from '@img/icons/arrow-dots.svg?url';
import SvgArrowRight from '@img/icons/arrow-right.svg?url';
import SvgArrowSimpleDown from '@img/icons/arrow-simple-down.svg?url';
import SvgArrowSimpleLeft from '@img/icons/arrow-simple-left.svg?url';
import SvgArrowSimpleRight from '@img/icons/arrow-simple-right.svg?url';
import SvgArrowSimpleUp from '@img/icons/arrow-simple-up.svg?url';
import SvgAward from '@img/icons/award.svg?url';
import SvgBookOpen from '@img/icons/book-open.svg?url';
import SvgBriefcase from '@img/icons/briefcase.svg?url';
import SvgBuild from '@img/icons/build.svg?url';
import SvgBusinessAlt from '@img/icons/business-alt.svg?url';
import SvgBusiness from '@img/icons/business.svg?url';
import SvgCalendar from '@img/icons/calendar.svg?url';
import SvgChevronDown from '@img/icons/chevron-down.svg?url';
import SvgChevronRight from '@img/icons/chevron-right.svg?url';
import SvgCircles from '@img/icons/circles.svg?url';
import SvgCloseCircle from '@img/icons/close-circle.svg?url';
import SvgClose from '@img/icons/close.svg?url';
import SvgConfirm from '@img/icons/confirm.svg?url';
import SvgConnect from '@img/icons/connect.svg?url';
import SvgCreate from '@img/icons/create.svg?url';
import SvgDesign from '@img/icons/design.svg?url';
import SvgDoubleArrowUp from '@img/icons/double-arrow-up.svg?url';
import SvgDropper from '@img/icons/dropper.svg?url';
import SvgEducation from '@img/icons/education.svg?url';
import SvgEye from '@img/icons/eye.svg?url';
import SvgFacebook from '@img/icons/facebook.svg?url';
import SvgFileHeart from '@img/icons/file-heart.svg?url';
import SvgFile from '@img/icons/file.svg?url';
import SvgFilter from '@img/icons/filter.svg?url';
import SvgGlobe from '@img/icons/globe.svg?url';
import SvgGovernance from '@img/icons/governance.svg?url';
import SvgGraphUp from '@img/icons/graph-up.svg?url';
import SvgGrid from '@img/icons/grid.svg?url';
import SvgIdea from '@img/icons/idea.svg?url';
import SvgInfo from '@img/icons/info.svg?url';
import SvgInformationSystems from '@img/icons/information-systems.svg?url';
import SvgIntegrate from '@img/icons/integrate.svg?url';
import SvgIntersectCircle from '@img/icons/intersect-circle.svg?url';
import SvgLeftRightArrows from '@img/icons/left-right-arrows.svg?url';
import SvgLink from '@img/icons/link.svg?url';
import SvgLinkedin from '@img/icons/linkedin.svg?url';
import SvgLogin from '@img/icons/login.svg?url';
import SvgLogout from '@img/icons/logout.svg?url';
import SvgMap from '@img/icons/map.svg?url';
import SvgMembership from '@img/icons/membership.svg?url';
import SvgMenu from '@img/icons/menu.svg?url';
import SvgMessage from '@img/icons/message.svg?url';
import SvgModify from '@img/icons/modify.svg?url';
import SvgNetwork from '@img/icons/network.svg?url';
import SvgOperate from '@img/icons/operate.svg?url';
import SvgPen from '@img/icons/pen.svg?url';
import SvgPodcast from '@img/icons/podcast.svg?url';
import SvgPresentationGraph from '@img/icons/presentation-graph.svg?url';
import SvgPresentation from '@img/icons/presentation.svg?url';
import SvgProcure from '@img/icons/procure.svg?url';
import SvgProtect from '@img/icons/protect.svg?url';
import SvgPullRequest from '@img/icons/pull-request.svg?url';
import SvgPuzzlePiece from '@img/icons/puzzle-piece.svg?url';
import SvgQuote from '@img/icons/quote.svg?url';
import SvgRefresh from '@img/icons/refresh.svg?url';
import SvgReport from '@img/icons/report.svg?url';
import SvgRocketAlt from '@img/icons/rocket-alt.svg?url';
import SvgRocket from '@img/icons/rocket.svg?url';
import SvgSearch from '@img/icons/search.svg?url';
import SvgSettings from '@img/icons/settings.svg?url';
import SvgSwitchVertical from '@img/icons/switch-vertical.svg?url';
import SvgTeam from '@img/icons/team.svg?url';
import SvgThink from '@img/icons/think.svg?url';
import SvgTick from '@img/icons/tick.svg?url';
import SvgTicket from '@img/icons/ticket.svg?url';
import SvgUpDownArrows from '@img/icons/up-down-arrows.svg?url';
import SvgUserAlt from '@img/icons/user-alt.svg?url';
import SvgUserEdit from '@img/icons/user-edit.svg?url';
import SvgUserPlus from '@img/icons/user-plus.svg?url';
import SvgUser from '@img/icons/user.svg?url';
import SvgVideoPlay from '@img/icons/video-play.svg?url';
import SvgVideoPlayerPlay from '@img/icons/video-player-play.svg?url';
import SvgVideo from '@img/icons/video.svg?url';
import SvgXTwitter from '@img/icons/x.svg?url';
import SvgYoutube from '@img/icons/youtube.svg?url';
import { Icon } from './icons';
export function getSvgIconUrl(icon) {
    switch (icon) {
        // Main Icons
        case Icon.AlertOctagon: {
            return SvgAlertOctagon;
        }
        case Icon.ArrowAltDown: {
            return SvgArrowAltDown;
        }
        case Icon.ArrowAltLeft: {
            return SvgArrowAltLeft;
        }
        case Icon.ArrowAltRight: {
            return SvgArrowAltRight;
        }
        case Icon.ArrowAltUp: {
            return SvgArrowAltUp;
        }
        case Icon.ArrowContinuous: {
            return SvgArrowContinuous;
        }
        case Icon.ArrowDots: {
            return SvgArrowDots;
        }
        case Icon.ArrowRight: {
            return SvgArrowRight;
        }
        case Icon.ArrowSimpleDown: {
            return SvgArrowSimpleDown;
        }
        case Icon.ArrowSimpleLeft: {
            return SvgArrowSimpleLeft;
        }
        case Icon.ArrowSimpleRight: {
            return SvgArrowSimpleRight;
        }
        case Icon.ArrowSimpleUp: {
            return SvgArrowSimpleUp;
        }
        case Icon.Award: {
            return SvgAward;
        }
        case Icon.BookOpen: {
            return SvgBookOpen;
        }
        case Icon.Briefcase: {
            return SvgBriefcase;
        }
        case Icon.Build: {
            return SvgBuild;
        }
        case Icon.Business: {
            return SvgBusiness;
        }
        case Icon.BusinessAlt: {
            return SvgBusinessAlt;
        }
        case Icon.Calendar: {
            return SvgCalendar;
        }
        case Icon.ChevronDown: {
            return SvgChevronDown;
        }
        case Icon.ChevronRight: {
            return SvgChevronRight;
        }
        case Icon.Confirm: {
            return SvgConfirm;
        }
        case Icon.Connect: {
            return SvgConnect;
        }
        case Icon.LeftRightArrows: {
            return SvgLeftRightArrows;
        }
        case Icon.Create: {
            return SvgCreate;
        }
        case Icon.Design: {
            return SvgDesign;
        }
        case Icon.DoubleArrowUp: {
            return SvgDoubleArrowUp;
        }
        case Icon.Dropper: {
            return SvgDropper;
        }
        case Icon.Education: {
            return SvgEducation;
        }
        case Icon.Eye: {
            return SvgEye;
        }
        case Icon.Facebook: {
            return SvgFacebook;
        }
        case Icon.File: {
            return SvgFile;
        }
        case Icon.FileHeart: {
            return SvgFileHeart;
        }
        case Icon.Filter: {
            return SvgFilter;
        }
        case Icon.Globe: {
            return SvgGlobe;
        }
        case Icon.Governance: {
            return SvgGovernance;
        }
        case Icon.Grid: {
            return SvgGrid;
        }
        case Icon.Info: {
            return SvgInfo;
        }
        case Icon.InformationSystems: {
            return SvgInformationSystems;
        }
        case Icon.Integrate: {
            return SvgIntegrate;
        }
        case Icon.IntersectCircle: {
            return SvgIntersectCircle;
        }
        case Icon.Link: {
            return SvgLink;
        }
        case Icon.Linkedin: {
            return SvgLinkedin;
        }
        case Icon.Membership: {
            return SvgMembership;
        }
        case Icon.Menu: {
            return SvgMenu;
        }
        case Icon.Modify: {
            return SvgModify;
        }
        case Icon.Network: {
            return SvgNetwork;
        }
        case Icon.Operate: {
            return SvgOperate;
        }
        case Icon.PullRequest: {
            return SvgPullRequest;
        }
        case Icon.PuzzlePiece: {
            return SvgPuzzlePiece;
        }
        case Icon.Quote: {
            return SvgQuote;
        }
        case Icon.Report: {
            return SvgReport;
        }
        case Icon.Team: {
            return SvgTeam;
        }
        case Icon.Think: {
            return SvgThink;
        }
        case Icon.Tick: {
            return SvgTick;
        }
        case Icon.Ticket: {
            return SvgTicket;
        }
        case Icon.Circles: {
            return SvgCircles;
        }
        case Icon.Close: {
            return SvgClose;
        }
        case Icon.CloseCircle: {
            return SvgCloseCircle;
        }
        case Icon.GraphUp: {
            return SvgGraphUp;
        }
        case Icon.Idea: {
            return SvgIdea;
        }
        case Icon.Login: {
            return SvgLogin;
        }
        case Icon.Logout: {
            return SvgLogout;
        }
        case Icon.Map: {
            return SvgMap;
        }
        case Icon.Message: {
            return SvgMessage;
        }
        case Icon.Pen: {
            return SvgPen;
        }
        case Icon.Podcast: {
            return SvgPodcast;
        }
        case Icon.Presentation: {
            return SvgPresentation;
        }
        case Icon.PresentationGraph: {
            return SvgPresentationGraph;
        }
        case Icon.Procure: {
            return SvgProcure;
        }
        case Icon.Protect: {
            return SvgProtect;
        }
        case Icon.Refresh: {
            return SvgRefresh;
        }
        case Icon.Rocket: {
            return SvgRocket;
        }
        case Icon.RocketAlt: {
            return SvgRocketAlt;
        }
        case Icon.Search: {
            return SvgSearch;
        }
        case Icon.Settings: {
            return SvgSettings;
        }
        case Icon.SwitchVertical: {
            return SvgSwitchVertical;
        }
        case Icon.UpDownArrows: {
            return SvgUpDownArrows;
        }
        case Icon.User: {
            return SvgUser;
        }
        case Icon.UserAlt: {
            return SvgUserAlt;
        }
        case Icon.UserEdit: {
            return SvgUserEdit;
        }
        case Icon.UserPlus: {
            return SvgUserPlus;
        }
        case Icon.Video: {
            return SvgVideo;
        }
        case Icon.VideoPlay: {
            return SvgVideoPlay;
        }
        case Icon.VideoPlayerPlay: {
            return SvgVideoPlayerPlay;
        }
        case Icon.XTwitter: {
            return SvgXTwitter;
        }
        case Icon.Youtube: {
            return SvgYoutube;
        }
        case Icon.None:
        default: {
            return '';
        }
    }
}
